import React from 'react';
import { BellIcon, ChevronRightIcon, MapPinIcon } from 'lucide-react';
import type { Sport } from '../../types/landing';
import { bestStatus, summarizePrograms, venueSportUrl, type VenueInventory } from '../../utils/inventory';
import { prototypeNavigate } from '../../utils/prototypeNav';
import { ProgramStatusBadge } from '../ProgramStatusBadge';
interface VenueCardProps {
  venue: VenueInventory;
  index: number;
  sport: Sport;
  citySlug: string;
  selected: boolean;
  onSelect: () => void;
}
export function VenueCard({
  venue,
  index,
  sport,
  citySlug,
  selected,
  onSelect
}: VenueCardProps) {
  const status = bestStatus(venue.sportPrograms);
  const summary = summarizePrograms(venue.sportPrograms);
  const url = venueSportUrl(citySlug, venue.id, sport.slug);
  const upcomingOnly = status === 'upcoming';
  return <li id={`venue-${venue.id}`} className={`border-l-4 bg-white px-4 py-4 transition-colors duration-150 ${selected ? 'border-brand-red bg-brand-mist' : 'border-transparent'}`} data-id="element-80" data-mp="3n0o9hmj9tlra">
      <div className="flex items-start gap-3" data-id="element-81" data-mp="1g8col6a544gu">
        <span className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white transition-colors duration-150 ${selected ? 'bg-brand-red' : 'bg-brand-navy'}`} aria-hidden="true" data-id="element-82" data-mp="1l87fvaxtuw2f">
          {index + 1}
        </span>
        <div className="min-w-0 flex-1" data-id="element-83" data-mp="ximsmfun5cnc">
          <div className="flex flex-wrap items-start justify-between gap-x-3 gap-y-1" data-id="element-84" data-mp="xjo5mpv7w97p">
            <h3 className="text-[15px] font-bold leading-snug text-brand-navy" data-id="element-85" data-mp="11jghbbfwqvha">
              <button type="button" onClick={onSelect} aria-pressed={selected} className="text-left hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-sky" data-id="element-86" data-mp="16jkxf0cwlo6z">
                {venue.name}
              </button>
            </h3>
            <ProgramStatusBadge status={status} data-id="element-87" data-mp="dudp59nndk8j" />
          </div>
          <p className="mt-0.5 text-xs text-brand-muted" data-id="element-88" data-mp="isypra6ta5xi">
            {venue.community} · {venue.areaName}
          </p>
          <p className="mt-2 text-sm text-brand-ink" data-id="element-89" data-mp="1m3ct8lgouzsy">
            {summary.ages} · {summary.days}
          </p>
          <p className="text-sm text-brand-muted" data-id="element-90" data-mp="1h5b17b1abq5c">
            {upcomingOnly ? `Next season: ${summary.season}` : summary.season}
          </p>
          <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2" data-id="element-91" data-mp="1qvmkc4tji5wt">
            <a href={url} onClick={e => {
            e.preventDefault();
            prototypeNavigate(`${sport.name} at ${venue.name}`, url);
          }} className="inline-flex items-center gap-1 rounded-sm bg-brand-red px-3.5 py-2 text-xs font-semibold text-white transition-colors duration-150 hover:bg-brand-redDark" data-id="element-92" data-mp="1qxqkqcs8cmsc">
              {upcomingOnly ? <BellIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-93" data-mp="175txgz5lfmc0" /> : null}
              {upcomingOnly ? 'Get Notified' : `View ${sport.name} Programs`}
              {!upcomingOnly && <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-94" data-mp="2inbrv81ab9lv" />}
            </a>
            <button type="button" onClick={onSelect} className="inline-flex items-center gap-1 text-xs font-medium text-brand-skyDark hover:underline" data-id="element-95" data-mp="2r31a68m2h7fw">
              <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-96" data-mp="2v31prwkwjooj" />
              Show on map
            </button>
          </div>
        </div>
      </div>
    </li>;
}